import React from 'react';
import { IconProps } from '../IconProps';

export const FeedbackIcon: React.FC<IconProps> = ({
	width = 22,
	height = 20,
	stroke = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 22 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		className={className}
	>
		<path
			d="M10 10.625C9.82741 10.625 9.6875 10.7649 9.6875 10.9375C9.6875 11.1101 9.82741 11.25 10 11.25C10.1726 11.25 10.3125 11.1101 10.3125 10.9375C10.3125 10.7649 10.1726 10.625 10 10.625"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10 8.33268V4.16602"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.125 15.625H9.375L4.375 19.375V15.625H1.875C1.18464 15.625 0.625 15.0654 0.625 14.375V1.875C0.625 1.18464 1.18464 0.625 1.875 0.625H18.125C18.8154 0.625 19.375 1.18464 19.375 1.875V14.375C19.375 15.0654 18.8154 15.625 18.125 15.625Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
